export default {
  "pl": {
    "session": {
      "error_internalserver": {
        "goback": "Wróć",
        "subtitle": "Ups! Wystąpił nieoczekiwany błąd.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Wróć",
        "subtitle": "Przepraszamy! Nie można znaleźć tej strony.",
        "title": "404"
      },
      "expired": {
        "text": "Twoja sesja wygasła z powodu braku aktywności. Ze względów bezpieczeństwa musisz zalogować się ponownie. \n\nKliknij „OK”, aby przejść do ekranu logowania.",
        "title": "Sesja wygasła"
      },
      "logout_impersonate": {
        "text": "Wylogowano podczas korzystania z widoku roli.",
        "title": "Zakończono korzystanie z widoku roli"
      },
      "noaccess": {
        "text": "Nie masz obecnie dostępu do tej strony. Nastąpi przekierowanie do strony głównej.",
        "title": "Odmowa dostępu dla hosta: {hostname}"
      }
    }
  }
}
